import TableContext from 'config/context/tableContext';
import React, { createContext, useContext, useMemo, useState } from 'react';

const MfImportContext = createContext();

export const MfImportProvider = ({ children }) => {
    const { tableStructures } = useContext(TableContext);
    const [step, setStep] = useState(1);
    const [pkey, setPkey] = useState(null);
    const [file, setFile] = useState(null);
    const [selectedPermission, setSelectedPermission] = useState('active');
    const [exist, setExist] = useState(true);
    const [selectedComposition, setSelectedComposition] = useState('');
    const [structs, setStructs] = useState([]);
    const [table, setTable] = useState({ fields: [], indexes: [], description: '' });
    const [instance, setInstance] = useState('');

    const allCompositionsList = useMemo(() =>
        new Set((tableStructures || []).map(({ type }) => type?.toLowerCase()).filter(Boolean)),
        [tableStructures]
    );

    const fileType = () => {
        const type = file.name.split('.').pop().toLowerCase();
        return type;
    }

    const resetMfContext = () => {
        setStep(1);
        setPkey(null);
        setFile(null);
        setSelectedPermission('active');
        setExist(true);
        setSelectedComposition('');
        setStructs([]);
        setTable({ fields: [], indexes: [], description: '' });
        setInstance('');
    };

    return (
        <MfImportContext.Provider
            value={{
                step,
                setStep,
                pkey,
                setPkey,
                file,
                fileType,
                setFile,
                selectedPermission,
                setSelectedPermission,
                exist,
                setExist,
                selectedComposition,
                setSelectedComposition,
                structs,
                setStructs,
                table,
                setTable,
                instance,
                setInstance,
                resetMfContext,
                allCompositionsList
            }}
        >
            {children}
        </MfImportContext.Provider>
    );
};

export const useMfImport = () => useContext(MfImportContext);
